import { createReducer, on } from '@ngrx/store';
import {
    loadContextDetails,
    loadContextDetailsFailure,
    loadContextDetailsSuccess,
    setMultipleContext,
    setSingleContext
} from '../actions';
import { ContextState } from '../context.state';

const initialState: ContextState = {
    singleProperty: null,
    multipleProperties: null,
    details: null,
    loaded: false,
    loading: false,
    error: null
};

export const contextReducer = createReducer(initialState,
    on(setSingleContext, (state, action) => ({
        ...state,
        singleProperty: action.property
    })),
    on(setMultipleContext, (state, action) => ({
        ...state,
        multipleProperties: action.properties
    })),

    on(loadContextDetails, state => ({
        ...state,
        details: null,
        loaded: false,
        loading: true,
        error: null
    })),

    on(loadContextDetailsSuccess, (state, { details }) => ({
        ...state,
        details: { ...details },
        loaded: true,
        loading: false,
        error: null
    })),

    on(loadContextDetailsFailure, (state, { error }) => ({
        ...state,
        loaded: false,
        loading: false,
        error
    }))
);
